import React from "react";

import "./LocationsForm.css";
import "../CompanyInfoForm.css";

import { ReactComponent as OfficeIcon } from "../../../../../assets/images/onboarding/customer.svg";
import { ReactComponent as BuildingIcon } from "../../../../../assets/images/subscriptions/building-line.svg";

const CHOICES = [
  {
    value: "existing",
    title: "Manage under existing account",
    description:
      "Share billing, users, and subscriptions. Copies details from Location 1 — review and update as needed.",
    Icon: BuildingIcon,
    iconClassName: "",
  },
  {
    value: "independent",
    title: "Manage as an independent location",
    description:
      "Maintain separate billing, subscriptions, and settings. Fill in all details yourself.",
    Icon: OfficeIcon,
    iconClassName: "LocationsForm__ChoiceIcon--office",
  },
];

export default function AddLocationChoice({
  selected,
  onSelect,
  disableExisting = false,
  title = "Add New Location",
  prompt = "How would you like to manage this location?",
}) {
  return (
    <div>
      <div className="OnboardingFormSubTitle OnboardingFormSubTitle--first">
        <span />
        <p className="OnboardingFormSubTitleText">{title}</p>
      </div>
      <p className="LocationsForm__Prompt">{prompt}</p>
      <div className="LocationsForm__Choices">
        {CHOICES.map(({
          value, title: choiceTitle, description, Icon, iconClassName,
        }) => {
          const disabled = disableExisting && value === "existing";
          const isSelected = selected === value;
          return (
            <button
              key={value}
              type="button"
              disabled={disabled}
              title={disabled ? "Not available for independently managed locations" : undefined}
              className={[
                "LocationsForm__Choice",
                isSelected ? "LocationsForm__Choice--selected" : "",
                disabled ? "LocationsForm__Choice--disabled" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => {
                if (!disabled) onSelect(value);
              }}
            >
              <div className="LocationsForm__ChoiceHeader">
                <span className="LocationsForm__ChoiceIconSlot">
                  <Icon className={`LocationsForm__ChoiceIcon ${iconClassName}`.trim()} />
                </span>
                <span className="LocationsForm__ChoiceTitle">{choiceTitle}</span>
              </div>
              <span className="LocationsForm__ChoiceDesc">{description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
